import { render } from "./xOnlyIcon.svg?vue&type=template&id=48114e46"
const script = {}
script.render = render

export default script